module.exports = __webpack_public_path__ + "assets1783936157458/img/kehu.9b75f3c0.svg";